export const breakpoints = {
    mobile: 767,
} as const;

export const media = {
    mobile: `@media (max-width: ${breakpoints.mobile}px)`,
} as const;
